import io from 'socket.io-client';
import GameSceneRace from './GameSceneRace';
import Consts from './Consts';
//import * as bip39 from '@scure/bip39';
//import { wordlist } from '@scure/bip39/wordlists/english';
import { Buffer } from 'buffer';
import { sha256 } from 'js-sha256';

import { ethers } from 'ethers-ts';

//import * as zlib from 'fast-zlib';
//import { Deflate, Inflate } from "zlibt2";

class Connection {
	
	gameSceneRace: GameSceneRace;

	socket: SocketIOClient.Socket;
	
	isConnected = false;
	
	tmpEntropyBase64: string = null!;
	
	constructor(gameSceneRace: GameSceneRace, connectUrl: string) {

		this.gameSceneRace = gameSceneRace;
		
		this.socket = io(connectUrl, { transports: [ 'websocket' ]});  

		this.socket.on('connect', () => {
			
			this.isConnected = true;
			
			console.log("connected!");

		});

		this.socket.on('r', (data: string) => {
			
			this.messageProcessor(data);

		});

	}
	/////////////////////////////////////////////////////////
	messageProcessor(message: string) {
		console.log("server: " + message);
		
		if (message != null) {
			const obj = JSON.parse(message);
			
			const cmd: number = obj.c;
			let params = null;
			
			if ((obj.p !== undefined) && (obj.p !== null)) {
				params = JSON.parse(obj.p);  // от этого наследия протокола в виде заворачивания в строку не забыть избавиться
			}
			
			console.log("server: cmd = " + cmd + ", params = " + params);
			
			switch(cmd) {
				case Consts.Command.ADD_CLIENT:
					this.addClient(params);
					break;
				
			}
			
		}
		
		
	}
	/////////////////////////////////////////////////////////
	getStorageDataObj() {
		let obj: any = null;
		const storageDataBase64 = localStorage.getItem(Consts.Common.LOCAL_STORAGE_AUTH_VAR_NAME);
		if (storageDataBase64 != null) {
			const storageData = Buffer.from(storageDataBase64, 'base64').toString('utf8');
			obj = JSON.parse(storageData);
		}
		return obj;
	}
	/////////////////////////////////////////////////////////
	addClient(params: any) {
		const storageDataObj: any = localStorage.getItem(Consts.Common.LOCAL_STORAGE_AUTH_VAR_NAME);
		if (storageDataObj == null) {
			// нет сохранённой сессии, создаём новый аккаунт
			
			//const mnemonic = bip39.generateMnemonic(wordlist);
			//const entropy = bip39.mnemonicToEntropy(mnemonic, wordlist);
			
			//this.tmpEntropyBase64 = Buffer.from(entropy).toString('base64'); 
			
			//localStorage.setItem(Consts.Common.LOCAL_STORAGE_AUTH_VAR_NAME, JSON.stringify({}));
			
			
			//const wallet = ethers.Wallet.fromMnemonic(mnemonic);
			
			const wallet = ethers.Wallet.createRandom();
			

			//console.log("ethers.Wordlist.length = " + ethers.wordlists.en.split(' ')
			
			console.log("address =", wallet.address)
			console.log('mnemonic =', wallet.mnemonic.phrase)
			console.log("privateKey =", wallet.privateKey)
			
			const entropyB64 = this.mnemonicToEntropyB64(wallet.mnemonic.phrase);
//			const index = ethers.wordlists.en.getWordIndex("girl");
//			console.log("index = " + index);
			
			console.log("entropyB64 = " + entropyB64);
			
			this.tmpEntropyBase64 = entropyB64;
			
			//const mnemonicCheck = this.entropyB64ToMnemonic(entropyB64);
			//console.log('mnemonicCheck =', mnemonicCheck);
			
			const pHash = sha256(wallet.mnemonic.phrase);
			const aHash = sha256(params.authStr + Consts.Common.AUTH_SALT);

			this.send(Consts.Command.CREATE_ACCOUNT, { pHash: pHash, aHash: aHash, inviteUid: null });
			
		} else {
			// есть сохранённая сессия, извлекаем connectionId и авторизовываемся
			this.send(Consts.Command.CONNECTION_ID_LOGIN, { connectionId: storageDataObj.connectionId });
		}
		
	}
	/////////////////////////////////////////////////////////
	send(cmd: number, params: any) {
		
		const obj: any = new Object();
		obj.c = cmd;
		obj.p = JSON.stringify(params);
		
		this.socket.emit("r", JSON.stringify(obj));
	}
	/////////////////////////////////////////////////////////
	mnemonicToEntropyB64(mnemonic: string) {
		const words = mnemonic.split(' ');
		
		const arr: number[] = [];
		
		for (let i = 0; i < words.length; i++) {
			const index = ethers.wordlists.en.getWordIndex(words[i]);
			arr.push(8 * Math.floor(index / 256));
			arr.push(index & 255);
		}

		const buffer =  Buffer.from(arr);
		
//		console.log("arr = " + arr);
//		console.log("buffer = " + buffer);
		
		return buffer.toString('base64');
	}
	entropyB64ToMnemonic(entropyB64: string) {
		const buffer = Buffer.from(entropyB64, "base64");
			
//		console.log("buffer(fromb64) = " + buffer);
//		console.log("buffer.length = " + buffer.length);
			
		let mnemonic = "";	
			
		for (let i = 0; i < buffer.length; i += 2) {
			
			const index = buffer[i] * 32 + buffer[i + 1]; 
			
			console.log("index = " + index);
			const word = ethers.wordlists.en.getWord(index);
			if (i > 0) {
				mnemonic += ' ';
			}
			mnemonic += word;
		}
		
		return mnemonic;
	}
	/////////////////////////////////////////////////////////
	
}
export default Connection;